import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { BoxWrapper, Modal, Button } from 'components/Base';
import { reduxForm, Field, Form, getFormValues } from 'redux-form';
import Fields from 'components/Fields';
import api from 'api';
import { Notify } from 'utils';
import { compose } from 'ramda';
import Store from 'store/store';
import selectors from 'store/selectors';
const { connect } = Store;

interface AddNotesModalProps {
  isModalOpen: boolean;
  closeModal: Function;
  caseInfo: any;
  formValues: any;
}

const AddNotesModal = ({
  isModalOpen,
  closeModal,
  caseInfo,
  formValues
}: AddNotesModalProps) => {
  const useStyles = makeStyles({
    summaryModal: {
      width: '800px',
      padding: '1rem',
      maxHeight: '80vh',
      overflowX: 'auto'
    },
    itemRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  });

  const classes = useStyles();

  const onSubmit = () => {
    api
      .editCase({
        caseInfo: {
          ...caseInfo,
          notes: formValues.notes
        }
      })
      .then(() => {
        closeModal();
        Notify.success('Risk analysis', 'Risk analysis notes saved');
      })
      .catch(() => {
        Notify.error('Unknown error', 'Please contact administrator');
      });
  };

  return (
    <Modal isOpen={isModalOpen} closeModalFunc={() => closeModal()}>
      <BoxWrapper title="Add Notes" closeModal={() => closeModal()}>
        <div className={classes.summaryModal}>
          <Form>
            <div
              style={{
                maxHeight: '400px',
                overflowX: 'auto',
                marginBottom: '5rem'
              }}
            >
              <Field
                name="notes"
                shrink
                fullWidth
                component={Fields.Text}
                multiline
                minRows={10}
                label="Notes"
                autoComplete="off"
              />
            </div>
          </Form>
          <div
            style={{
              paddingTop: '1rem',
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              position: 'absolute',
              bottom: 0,
              marginLeft: '-1rem',
              padding: '1rem',
              backgroundColor: 'white',
              borderRadius: '25px'
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => closeModal()}
            >
              Cancel
            </Button>
            <Button
              key="save"
              variant="contained"
              color="secondary"
              onClick={() => {
                onSubmit();
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </BoxWrapper>
    </Modal>
  );
};

export default compose(
  connect((state: any) => ({
    caseInfo: selectors.caseSelectors.case(state),
    initialValues: {
      notes: selectors.caseSelectors.caseNotes(state)
    },
    formValues: getFormValues('addNotes')(state)
  })),
  reduxForm({
    form: 'addNotes',
    enableReinitialize: true
  })
)(AddNotesModal);
